module.exports = __webpack_public_path__ + "static/media/home-solve-office.214a05bf.jpg";